import React from 'react';
import { Popover, Typography, Box } from '@mui/material';

interface InfoPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
  text: string;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({ anchorEl, onClose, open, text }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box sx={{ p: 1, maxWidth: 250 }}>
        <Typography sx={{ fontSize: '12px' }}>{text}</Typography>
      </Box>
    </Popover>
  );
};

export default InfoPopover;
